<script lang="ts" setup>
  import { pageReport, useQidianService } from '@/composable'
  import { showViewAutoPlay } from '@/composable/swiper'
  import { BtnType, ColorType } from '@/define'
  import { getAssetsFile } from '@/utils'
  import BaseBtn from '@components/btn/BaseBtn.vue'
  import SvgIcon from '@components/svgIcon/SvgIcon.vue'
  import { useHead } from '@vueuse/head'
  import SwiperCore, { Autoplay } from 'swiper'
  import 'swiper/css'
  import { Swiper as SwiperClass } from 'swiper/types'
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import { computed, ref } from 'vue'
  import GameCarousel from './components/GameCarousel.vue'

  SwiperCore.use([Autoplay])

  useHead({
    title: '内容引擎_定制化的活动模板，轻松解决企业营销难题',
    meta: [
      {
        name: 'description',
        content:
          '【内容引擎_定制化的活动模板，轻松解决企业营销难题】是内容引擎为您精心挑选的关于【定制化的活动模板】的相关模板资源信息，共涉及相关场景的模板资源推荐。内容引擎是一个简单高效的游戏化营销活动创建平台，提供大量免费设计素材和游戏化模板、H5、小程序，可为您提供更高效的营销活动创建，三分钟就能做出一场高转化的活动。在线即可完成制作，轻松解决企业营销问题。',
      },
      {
        name: 'keywords',
        content: '营销,游戏化,互动,H5,活动,低成本,获客,引流,裂变,留存,转化,定制',
      },
    ],
  })
  const items = ref([
    { message: '在线咨询', messageone: '对接项目经理梳理需求明确方案', background: 'customize/ring1.png' },
    { message: '签订合同', messageone: '签订项目方案合同', background: 'customize/ring2.png' },
    { message: '设计出样确认', messageone: '官方设计对接服务品牌保障', background: 'customize/ring3.png' },
    { message: '活动开发', messageone: '实际活动项目开发落地交付', background: 'customize/ring4.png' },
    { message: '活动上线', messageone: '售后客服提供专业保障服务', background: 'customize/ring5.png' },
  ])
  const ranges = [
    {
      message: '支持答题、投票、抽奖、红包、集字助力、许愿树、孔明灯、节日头像、猜灯谜、新年签、贺卡等100多种活动玩法',
      image: 'customize/range1.png',
    },
    { message: '支持会场签到、抽奖、暖场互动、趣味游戏等多种主流玩法', image: 'customize/range2.png' },
    { message: '承办企业品牌活动、声量传播等各类整合营销活动', image: 'customize/range3.png' },
  ]
  const prev = () => {
    if (currentIndex.value <= 0) {
      currentIndex.value = 2
    } else {
      currentIndex.value--
    }
    swiperObj.value?.slideTo(currentIndex.value)
  }
  const next = () => {
    if (currentIndex.value >= 2) {
      currentIndex.value = 0
    } else {
      currentIndex.value++
    }
    swiperObj.value?.slideTo(currentIndex.value)
  }

  const currentIndex = ref(0)
  const choose = (index: number) => {
    swiperObj.value?.slideTo(index)
  }
  const onSlideChange = (swiper: SwiperClass) => {
    currentIndex.value = swiper.activeIndex
  }
  const swiperObj = ref<SwiperClass>()
  const setControllerSwiper = (swiper: SwiperClass) => {
    swiperObj.value = swiper
  }
  const tabList = [
    {
      key: 1,
      name: '线上活动营销',
      noCheckImg: getAssetsFile('root/game-case-nocheck_1.png'),
      checkImg: getAssetsFile('root/game-case-check_1.png'),
    },
    {
      key: 2,
      name: '现场大屏活动',
      noCheckImg: getAssetsFile('root/game-case-nocheck_2.png'),
      checkImg: getAssetsFile('root/game-case-check_2.png'),
    },
    {
      key: 3,
      name: '企业品宣',
      noCheckImg: getAssetsFile('root/game-case-nocheck_3.png'),
      checkImg: getAssetsFile('root/game-case-check_3.png'),
    },
  ]
  const tabLength = computed(() => tabList.length)

  const { onServiceClick, loading } = useQidianService()

  const swiperRef = ref<HTMLElement | null>(null)
  showViewAutoPlay(swiperRef, swiperObj)
  pageReport({
    page: 'pc_customized',
  })
</script>

<template>
  <div class="header">
    <div class="header-content">
      <div class="header-content-one">
        <div class="header-content-one-fontone">游戏化互动营销 定制服务</div>
        <div class="header-content-one-fonttwo">为品牌客户打造全场景式游戏化营销解决服务</div>
        <div style="margin-top: 80px; margin-left: 40px">
          <base-btn
            :loading="loading"
            id="dxhd_customer_service"
            :type="BtnType.SHOW"
            :color="ColorType.PRIMARY"
            @click="onServiceClick"
            >立即咨询</base-btn
          >
        </div>
      </div>
      <video src="@/assets/videos/customize/customize-header.webm" :loop="true" autoplay muted></video>
    </div>
  </div>
  <div class="case">
    <div class="case-body">
      <div class="case-body-title">线上互动游戏案例</div>
      <game-carousel></game-carousel>
    </div>
  </div>
  <div class="server-range">
    <div class="server-range-child">
      <div class="server-range-title">定制服务范围</div>
      <div class="tab-box">
        <template v-for="(item, index) in tabList" :key="item.key">
          <div class="tab-point" :class="{ active: currentIndex === index }" @click="choose(index)">
            <img class="tab-icon" :src="currentIndex === index ? item.checkImg : item.noCheckImg" />
            <span>{{ item.name }}</span>
            <div class="icon-down" v-if="currentIndex === index"></div>
          </div>
        </template>
      </div>
      <div ref="swiperRef" class="carousel-box">
        <div class="server-range-round" @click="prev">
          <svg-icon icon-name="prev" icon-size="14" :color="currentIndex === 0 ? '#3D485D' : '#2B84FF'"></svg-icon>
        </div>
        <swiper
          :slidesPerView="1"
          :centeredSlides="true"
          :allowTouchMove="false"
          :autoplay="{ pauseOnMouseEnter: true, disableOnInteraction: false, delay: 10000 }"
          :speed="600"
          @swiper="setControllerSwiper"
          @slideChange="onSlideChange"
          class="server-range-photo"
        >
          <swiper-slide v-for="range in ranges" :key="range.message">
            <div class="server-range-pag">
              <div class="server-range-left">
                <div class="server-range-pagone">定制服务范围</div>
                <div class="server-rang-divier"></div>
                <div class="server-range-pagtwo">
                  {{ range.message }}
                </div>
              </div>
              <div class="server-range-right">
                <img :src="getAssetsFile(range.image)" />
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <!-- <a-carousel class="server-range-photo" indicator-type="never" show-arrow="never" v-model:current="currentIndex">
          <a-carousel-item v-for="range in ranges" :key="range.message">
            <div class="server-range-pag">
              <div class="server-range-left">
                <div class="server-range-pagone">定制服务范围</div>
                <div class="server-rang-divier"></div>
                <div class="server-range-pagtwo">
                  {{ range.message }}
                </div>
              </div>
              <div class="server-range-right">
                <img :src="getAssetsFile(range.image)" />
              </div>
            </div>
          </a-carousel-item>
        </a-carousel> -->
        <div class="server-range-round" style="left: 1620px" @click="next">
          <svg-icon
            icon-name="next"
            icon-size="14"
            :color="currentIndex === tabLength - 1 ? '#3D485D' : '#2B84FF'"
          ></svg-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="server-flow">
    <div class="server-flow-title">定制服务流程</div>
    <div class="server-flow-boxs">
      <div class="box-bg" v-for="(item, index) in items" :key="item.message">
        <div class="box" :style="{ 'background-image': `url('${getAssetsFile(item.background)}')` }">
          <div class="ball-one">{{ index + 1 }}</div>
          <div class="box-content">
            <div class="box-one">{{ item.message }}</div>
            <div class="box-two">{{ item.messageone }}</div>
          </div>
          <div class="box-arrow">
            <img class="row" style="left: 493px" src="@images/customize/server-flow-arrow.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="partner">
    <div class="partner-child">
      <div class="partner-title">专注整合营销，与500+企业共同创造价值</div>
      <div style="text-align: center"><img src="@images/customize/logos.png" alt="" /></div>
    </div>
  </div>
  <div class="marketing-box">
    <div class="marketing-box-main">
      <div class="title">联系我们，获取专属营销定制服务</div>
      <div class="btn">
        <base-btn
          id="dxhd_customer_service"
          :loading="loading"
          :type="BtnType.SHOW"
          :color="ColorType.WHITE"
          :font-size="16"
          @click="onServiceClick"
          >联系客服 >></base-btn
        >
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 680px;
    background-image: url('@images/customize/header-background.png');
    background-repeat: no-repeat;
    background-size: cover;

    .header-content {
      display: flex;
      width: 1440px;
      height: 100%;

      .header-content-one {
        display: block;
        width: 455px;
        height: 100%;

        .header-content-one-fontone {
          width: 455px;
          height: 160px;
          margin-top: 150px;
          margin-left: 40px;
          color: #1d2129;
          font-weight: bold;
          font-size: 60px;
          font-family: AlibabaPuHuiTiB, sans-serif;
          line-height: 80px;
        }

        .header-content-one-fonttwo {
          width: 480px;
          height: 33px;
          margin-left: 40px;
          color: #3d485d;
          font-weight: 400;
          font-size: 24px;
          font-family: PingFangSC-Regular, 'PingFang SC', sans-serif;
          line-height: 80px;
        }
      }

      video {
        width: 1003px;
        height: 596px;
        margin-top: 44px;
      }
    }
  }

  .case {
    display: flex;
    justify-content: center;
    width: 100%;
    overflow: hidden;

    .case-body {
      width: 1440px;
      height: 100%;
      padding-bottom: 100px;

      .case-body-title {
        width: 320px;
        height: 56px;
        margin: auto;
        margin-top: 100px;
        margin-bottom: 60px;
        color: #1d2129;
        font-weight: 600;
        font-size: 40px;
        font-family: PingFangSC-Semibold, 'PingFang SC', sans-serif;
        line-height: 56px;
      }

      .case-body-logos {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        width: 480px;
        height: 91px;
        margin: auto;

        .case-body-logo {
          width: 60px;
          height: 60px;
          margin-right: 40px;

          img {
            width: 60px;
            height: 60px;
          }
        }

        &:nth-child(5) {
          margin-right: 0;
        }
      }

      .case-body-content {
        position: relative;
        width: 1440px;
        height: 648px;
        margin-top: 50px;
      }
    }
  }

  .server-range {
    position: relative;
    width: 100%;
    height: 1052px;
    overflow: hidden;
    background: #3d485d;

    .tab-box {
      display: flex;
      width: 1200px;
      height: 124px;
      margin-bottom: 95px;
      border-radius: 10px;
    }

    .tab-point {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(100% / 3);
      height: 100%;
      color: @black;
      font-weight: 500;
      font-size: 24px;
      font-family: PingFangSC-Medium, 'PingFang SC', sans-serif;
      background: #fff;
      cursor: pointer;

      .tab-icon {
        width: 60px;
        margin-right: 14px;
      }

      .icon-down {
        position: absolute;
        bottom: -20px;
        width: 0;
        height: 0;
        color: @primary-color;
        border: 10px solid transparent;
        border-top-color: white;
      }

      &:first-child {
        border-radius: 10px 0 0 10px;
      }

      &:last-child {
        border-radius: 0 10px 10px 0;
      }
    }

    .active {
      color: #fff;
      background: @primary-color;

      .icon-down {
        border-top-color: @primary-color;
      }
    }

    .server-range-child {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 1440px;
      margin: 0 auto;
    }

    .carousel-box {
      display: flex;
      align-items: center;
    }

    .server-range-photo {
      width: 1200px;
      height: 527px;
      margin: 0 60px;
      // margin-top: 95px;
    }

    .server-range-round {
      // position: absolute;
      // top: 659px;
      // left: 240px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;
      background: #e8f0fc;
      border-radius: 50px;

      .left {
        width: 11px;
        height: 11px;
        margin-top: 24px;
        margin-left: 25px;
        border: 2px solid #2b84ff;
        border-top: 0;
        border-right: 0;
        transform: rotate(45deg);
      }

      .right {
        width: 11px;
        height: 11px;
        margin-top: 24px;
        margin-left: 22px;
        border: 2px solid #2b84ff;
        border-bottom: 0;
        border-left: 0;
        transform: rotate(45deg);
      }
    }

    .server-range-title {
      width: 240px;
      height: 56px;
      margin: auto;
      margin-top: 100px;
      margin-bottom: 50px;
      color: #fff;
      font-weight: 600;
      font-size: 40px;
      font-family: PingFangSC-Semibold, 'PingFang SC', sans-serif;
      line-height: 56px;
    }

    .server-range-row {
      width: 1200px;
      height: 124px;
      margin: auto;
      margin-top: 50px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 0 20px 0 #d7e0ed;

      .row-col {
        position: absolute;
        top: 48px;
        left: 164px;
        display: inline-block;
        width: 144px;
        height: 33px;
        font-weight: 500;
        font-size: 24px;
        font-family: PingFangSC-Medium, 'PingFang SC', sans-serif;
        line-height: 33px;
      }

      .col-img {
        position: absolute;
        top: 23px;
        left: 93px;
        width: 52px;
        height: 74px;
      }
    }

    .server-range-pag {
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      background: #3d485d;

      .server-range-left {
        margin-top: 70px;
      }

      .server-range-right {
        img {
          width: 620px;
          height: 527px;
        }
      }

      .server-range-pagone {
        display: inline-block;
        width: 240px;
        height: 56px;
        color: #fff;
        font-weight: 600;
        font-size: 40px;
        font-family: PingFangSC-Semibold, 'PingFang SC', sans-serif;
        line-height: 56px;
      }

      .server-range-pagtwo {
        display: inline-block;
        width: 520px;
        height: 96px;
        color: #d3d3d3;
        font-weight: 300;
        font-size: 24px;
        font-family: PingFangSC-Light, 'PingFang SC', sans-serif;
        line-height: 48px;
      }

      .server-rang-divier {
        width: 36px;
        height: 6px;
        margin-top: 24px;
        margin-bottom: 70px;
        background: linear-gradient(90deg, #0ce5ed 0%, #2b84ff 100%);
        border-radius: 4px;
      }
    }
  }

  .server-flow {
    position: relative;
    width: 100%;
    height: 690px;
    overflow: hidden;

    .server-flow-title {
      width: 240px;
      height: 56px;
      margin: auto;
      margin-top: 100px;
      color: #1d2129;
      font-weight: 600;
      font-size: 40px;
      font-family: PingFangSC-Semibold, 'PingFang SC', sans-serif;
      line-height: 56px;
    }

    .server-flow-boxs {
      display: flex;
      width: 1460px;
      height: 292px;
      margin: auto;
      margin-top: 115px;

      .box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 292px;
        height: 292px;
        background-size: 292px 292px;

        .ball-one {
          position: absolute;
          top: -30px;
          width: 60px;
          height: 60px;
          color: #3d485d;
          font-weight: 600;
          font-size: 40px;
          font-family: Oswald-SemiBold, Oswald, sans-serif;
          line-height: 60px;
          text-align: center;
          background: #d5e7ff;
          border-radius: 50px;
        }

        .box-one {
          width: 168px;
          height: 40px;
          margin: auto;
          color: #3d485d;
          font-weight: 600;
          font-size: 28px;
          font-family: PingFangSC-Semibold, 'PingFang SC', sans-serif;
          line-height: 40px;
          text-align: center;
        }

        .box-two {
          width: 188px;
          height: 56px;
          margin: auto;
          margin-top: 16px;
          color: #7e97c6;
          font-weight: 400;
          font-size: 20px;
          font-family: PingFangSC-Regular, 'PingFang SC', sans-serif;
          line-height: 28px;
          text-align: center;
        }

        .box-arrow {
          position: absolute;
          right: -22px;
          z-index: 10;

          .row {
            width: 48px;
            height: 48px;
          }
        }
      }

      .box-bg {
        &:nth-child(2n) {
          .box {
            .ball-one {
              top: auto;
              bottom: -30px;
            }
          }
        }

        &:nth-child(5) {
          .box {
            .box-arrow {
              display: none;
            }
          }
        }
      }
    }
  }

  .partner {
    width: 100%;
    height: 636px;
    background: #f7f8fa;

    .partner-child {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 1440px;
      margin: 0 auto;
    }

    .partner-title {
      padding-top: 100px;
      color: #1d2129;
      font-weight: 600;
      font-size: 40px;
      font-family: PingFangSC-Semibold, 'PingFang SC', sans-serif;
      line-height: 56px;
    }

    img {
      width: 1446px;
      height: 320px;
      margin: auto;
      margin-top: 60px;
    }
  }

  .marketing-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 310px;
    background-image: url('@images/root/marketing-bg.jpg');
    background-size: cover;

    .marketing-box-main {
      display: flex;
      flex-direction: column;
      align-items: center;

      .title {
        color: #fff;
        font-weight: 500;
        font-size: 40px;
        font-family: PingFangSC-Medium, 'PingFang SC', sans-serif;
        line-height: 56px;
      }

      .btn {
        margin-top: 24px;
      }
    }
  }

  .none {
    display: none;
  }

  .font-color {
    color: #fff;
  }

  .backgrond {
    background: #2b84ff;
  }
</style>
